import { AlertTriangle } from 'lucide-react';

const DeleteConfirm = ({ message, onConfirm, onCancel }) => (
  <div className="sp-modal-backdrop" onClick={onCancel}>
    <div className="sp-modal" onClick={e => e.stopPropagation()}>
      <div className="sp-modal__icon sp-modal__icon--danger">
        <AlertTriangle size={28} />
      </div>
      <h3 className="sp-modal__title">Confirmar eliminación</h3>
      <p className="sp-modal__text">{message}</p>
      <div className="sp-modal__actions">
        <button className="sp-btn sp-btn--light" onClick={onCancel}>Cancelar</button>
        <button className="sp-btn sp-btn--danger" onClick={onConfirm}>Eliminar</button>
      </div>
    </div>
  </div>
);

export default DeleteConfirm;